import * as React from "react";
import { ArrowUpRight, Mail, Phone } from "lucide-react";
import { BRAND, NAV_LINKS } from "@/constants/brand";

const LEGAL = [
  { label: "Impressum", href: "/impressum" },
  { label: "Datenschutz", href: "/datenschutz" },
  { label: "AGB", href: "/#agb" },
];

const SERVICES = [
  { label: "Website-Abo", href: "/#preise" },
  { label: "Pakete", href: "/#pakete" },
  { label: "Google Ads", href: "/#leistungen" },
  { label: "SEO", href: "/#leistungen" },
  { label: "Meta Ads", href: "/#leistungen" },
];

export const SiteFooter = () => (
  <footer
    id="footer"
    className="relative isolate overflow-hidden border-t border-border/60 bg-[hsl(0_0%_0%)]"
  >
    <div
      aria-hidden
      className="absolute left-1/2 top-0 -z-10 h-[380px] w-[900px] -translate-x-1/2 rounded-full bg-[radial-gradient(closest-side,hsl(230_90%_50%/0.12),transparent)] blur-3xl"
    />

    <div className="mx-auto max-w-[1500px] px-5 pb-12 pt-20 sm:px-8 lg:px-12 lg:pt-24">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-10">
        {/* Marke */}
        <div className="lg:col-span-4">
          <div className="flex items-center gap-4">
            <img
              src={BRAND.logoMark}
              alt="Vision One"
              className="h-12 w-auto motion-safe:animate-logo-glow"
              style={{ animationDuration: "8s" }}
            />
            <img
              src={BRAND.logoWordmark}
              alt=""
              aria-hidden
              className="h-8 w-auto opacity-90"
            />
          </div>

          <p className="mt-7 max-w-sm text-sm font-light leading-relaxed text-muted-foreground">
            Individuelles Webdesign, Hosting und Betreuung im planbaren
            Monatsabo – für kleine und mittlere Unternehmen.
          </p>

        </div>

        {/* Navigation */}
        <div className="lg:col-span-2">
          <p className="font-display text-[11px] font-light uppercase tracking-[0.28em] text-foreground/80">
            Seiten
          </p>
          <ul className="mt-6 flex flex-col gap-3.5">
            {NAV_LINKS.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  className="text-sm font-light text-muted-foreground transition-colors duration-300 hover:text-foreground"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <p className="font-display text-[11px] font-light uppercase tracking-[0.28em] text-foreground/80">
            Leistungen
          </p>
          <ul className="mt-6 flex flex-col gap-3.5">
            {SERVICES.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  className="text-sm font-light text-muted-foreground transition-colors duration-300 hover:text-foreground"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Impressum */}
        <div className="lg:col-span-3">
          <p className="font-display text-[11px] font-light uppercase tracking-[0.28em] text-foreground/80">
            Impressum
          </p>

          <address className="mt-6 flex flex-col gap-3.5 not-italic">
            <a
              href="mailto:info@vision-one.io"
              className="flex items-center gap-3 text-sm font-light text-muted-foreground transition-colors duration-300 hover:text-foreground"
            >
              <Mail className="h-4 w-4 shrink-0 text-primary-glow" strokeWidth={1.5} />
              info@vision-one.io
            </a>
            <a
              href="tel:+4915567304351"
              className="flex items-center gap-3 text-sm font-light text-muted-foreground transition-colors duration-300 hover:text-foreground"
            >
              <Phone className="h-4 w-4 shrink-0 text-primary-glow" strokeWidth={1.5} />
              +49 1556 7304351
            </a>
          </address>

          <p className="mt-5 text-xs font-light leading-relaxed text-muted-foreground/75">
            Vollständige Anbieterkennzeichnung im{" "}
            <a
              href="/impressum"
              className="underline underline-offset-2 transition-colors hover:text-foreground"
            >
              Impressum
            </a>
          </p>
        </div>
      </div>

      {/* CTA-Leiste */}
      <div className="mt-16 flex flex-col items-start gap-5 border-t border-border/70 pt-8 sm:flex-row sm:items-center sm:justify-between">
        <p className="font-display text-sm font-light tracking-wide text-foreground/85">
          Bereit für deinen kostenlosen Entwurf?
        </p>
        <a
          href="#kontakt"
          className="group inline-flex items-center gap-2 font-display text-sm font-light tracking-wide text-primary-glow transition-colors duration-300 hover:text-foreground"
        >
          Jetzt anfragen
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </div>

      <div className="mt-8 flex flex-col gap-4 border-t border-border/60 pt-8 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-xs font-light text-muted-foreground/70">
          © {new Date().getFullYear()} Vision One · Alle Rechte vorbehalten
        </p>
        <ul className="flex flex-wrap gap-6">
          {LEGAL.map((link) => (
            <li key={link.label}>
              <a
                href={link.href}
                className="text-xs font-light text-muted-foreground/70 transition-colors duration-300 hover:text-foreground"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </footer>
);
